import _ from 'lodash';
import dynamic from 'next/dynamic';
import ConfirmButton from 'src/components/widget/confirm-button';
import { KEY_ADS_POSITION } from 'src/utils/ads/dynamic-ads';
import { convertDatasets } from 'src/utils/helper';
import styled from 'styled-components';
const DynamicAds = dynamic(import('src/utils/ads/dynamic-ads'), { ssr: true });

function SectionOne ({ id, className, data, showData, ads, showAds }) {
  if (_.isEmpty(data?.dataSet)) return null;
  const bgImage = _.find(data?.dataSet, (el) => el?.key === 'background-image')?.value;
  const bgImageMobile = convertDatasets(data?.dataSet, 'background-image-mobile', true);
  const bgContent = _.find(data?.dataSet, (el) => el?.key === 'content-image')?.value;
  const bgContentMobile = convertDatasets(data?.dataSet, 'content-image-mobile', true);
  const buttonVote = convertDatasets(data?.dataSet, 'ปุ่มโหวต', true);
  return (
    <SectionWrapper id={id} bgImage={bgImage} bgImageMobile={bgImageMobile || bgImage} className={className}>
      <div className='container'>
        <picture>
          {!_.isEmpty(bgContentMobile) && <source media='(max-width: 768px)' srcSet={bgContentMobile} />}
          <img className='content-image' src={bgContent} />
        </picture>
        {(!_.isEmpty(buttonVote) && showData) && <a href={'/vote'} target='_self' className='btn-vote'>
        <ConfirmButton className='button' child={buttonVote} />
      </a>}
      </div>
      {(showAds && !_.isEmpty(ads)) && <DynamicAds position={KEY_ADS_POSITION.BILLBOARD} data={ads} />}
    </SectionWrapper>
  );
}

const SectionWrapper = styled.div`
    position: relative;
    width: 100vw;
    height: auto;
    background-image: url(${props => props.bgImage});
    background-size: cover;
    background-position: center;
    @media (max-width: 768px) {
      background-image: url(${props => props.bgImageMobile});
    }
    .btn-vote {
      position: absolute;
      z-index: 10;
      bottom: 12%;
      left: 50%;
      transform: translate(-50%, 0%);
      @media (max-width: 768px) {
        bottom: 10%;
      }
    }

    .container {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      margin: auto;
      width: 100%;
      max-width: 1200px;
      margin: auto;
      height: auto;
      padding: 0 15px;
      justify-content: space-between;
      @media (max-width: 768px) {
       padding: 0;
        
      }
    }
    picture {
        width: 100%;
    }
    .content-image {
        display: block;
        position: relative;
        width: 100%;
    }
`;
export default SectionOne;
